import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import { isDevEnv } from '../manager/host-manager';

const name = process.env.REACT_APP_PROJECT_NAME;
const version = process.env.REACT_APP_PROJECT_VERSION;
const release = `${name}@${version}`;

console.log('release', release);

if (!isDevEnv) {
  Sentry.init({
    dsn: 'https://731218daa5be4ab393db5621937e6e75@o4504587122900992.ingest.sentry.io/4504587126177794',

    // debug: isDevEnv,
    // enabled: !isDevEnv,

    // release: "my-project-name@" + process.env.npm_package_version,
    release,

    enabled: true,

    integrations: [
      Sentry.browserTracingIntegration({
        // See docs for support of different versions of variation of react router
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
        routingInstrumentation: Sentry.reactRouterV6BrowserTracingIntegration(
          useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes
        ),
      }),
      Sentry.browserProfilingIntegration(),
    ],

    // replaysSessionSampleRate: 0,
    // replaysOnErrorSampleRate: 1.0,
    // integrations: [new BrowserTracing(), new Sentry.Replay()],
    // tracesSampler: (context) => {
    //   // TODO log(Flatted.stringify(context, null, '  '));
    //   return tracesSampleRate;
    // },

    tracesSampleRate: 0.2,
    profilesSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
  });
}

// export { sentrySetup, captureMessage };
// export { sentrySetup };
